export default function ResolveAttrValueIfNull(value) {
    
    if (!value || value === "" || value === undefined) {
        return undefined
    } 

    return value;
}

 